// extracted by mini-css-extract-plugin
export default {"pageTitleWrap":"page-title_pageTitleWrap__DX+KY"};